import { useRouteShellContext } from "@components/routeShellContext"
import * as m from "@paraglide/messages"
import type { HomeProps } from "@site-types/components/home"
import type { ContentImage } from "@site-types/content"
import Agency from "./Agency"
import Brands from "./Brands"
import ScrollArrow from "./ScrollArrow"
import Stage from "./Stage"

export function Home({ settings }: HomeProps) {
  const { locale } = useRouteShellContext()
  const graphicText = m.home_graphicText({}, { locale: locale }) ?? ""

  return (
    <div
      className="min-h-[100dvh]"
      data-testid="home-content"
    >
      <section
        className="relative flex min-h-[100dvh] w-full flex-col items-center justify-center overflow-visible text-center [--font-size:25vh] [--letter-spacing:0em] [scroll-snap-align:start]"
        data-testid="home-stage"
      >
        <Stage graphicText={graphicText} />
        <ScrollArrow
          href="#agency"
          label="Scroll to agency"
        />
      </section>
      <Agency gamersImage={settings.homePageGamersImage as ContentImage | undefined} />
      <Brands
        brandImage={settings.homePageBrandImage as ContentImage | undefined}
        settings={settings}
      />
    </div>
  )
}

export default Home
